import {HttpClient} from '@angular/common/http';
import { Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DxTreeListComponent} from 'devextreme-angular';
import {CatalogTreeComponent} from '../../../shared/catalog-tree/catalog-tree.component';
import {confirm, custom} from 'devextreme/ui/dialog';
import Validator from 'devextreme/ui/validator';
import {Catalog} from '../../../Model/Catalog/Catalog';
import {ProductState} from '../../../Model/Catalog/ProductState';
import {AddItem} from '../../../Model/Dto/AddItem';
import {CatalogItem} from '../../../Model/Dto/CombineCatalog/CatalogItem';
import {TransferCatalogItem} from '../../../Model/Dto/CombineCatalog/TransferCatalogItem';
import {StringResponse} from '../../../Model/Dto/StringResponse';
import {TreeItem} from '../../../Model/Dto/TreeItem';
import {Message} from '../../../Model/System/Message';
import {Customer} from '../../../Model/User/Customer';
import {CatalogService} from '../../../Services/CatalogManagement/catalog.service';
import {CombineCatalogService} from '../../../Services/CatalogManagement/combineCatalog.service';
import {ModelService} from '../../../Services/model.service';
import {ActivatedRoute} from '@angular/router';
import {InvoiceSettingDto} from '../../../Model/Dto/InvoiceSettingDto';
import {InvoiceService} from '../../../Services/invoice.service';
import {ClassifaiSetting} from '../../../Model/Dto/ClassifaiSetting';
import {LoginService} from "../../../Services/login.service";
import {SearchForm} from '../../../Model/Dto/SearchForm';
import {SearchFormsComponent} from '../../catalog/searchForms/search-forms.component';
import {SearchFormsService} from '../../../Services/SearchForms/searchforms.service';

@Component({
    selector: 'combineCatalogs',
    templateUrl: 'combineCatalogs.component.html',
    styleUrls: ['combineCatalogs.component.css'],
    standalone: false
})
export class CombineCatalogsComponent implements OnInit {
  txtNoFullCatalog: string;
  txtAddCategory: string;
  txtDeleteCategory: string;
  txtDeleteProd: string;
  txtLoading: string;
  txtNoCategoriesOrCatalogInProd: string;
  txtNoProdInChild: string;
  txtNoMasterInProd: string;
  txtNoProdInSelf: string;
  txtNoCatInSelf: string;
  txtExceedsMaxTotalCount: string;

  txtNoFilteredCatInCat: string;
  txtNoMoveCategoriesRecursive: string;
  txtNoMoveVarAlone: string;
  txtNoProdInCatalog: string;
  txtNoCategoryInCatalog: string;
  txtNoRefForCatalog: string;
  txtNoRefForVar: string;
  txtNoRefInProd: string;
  txtOnlyProdCategoriesOrCatalog: string;
  txtOnlyMasterOrVar: string;
  txtSourceEqualsTarget: string;
  txtNoMoveChildInCat: string;

  menuItems = [];
  isCatalogSelected: boolean;
  isCategorySelected: boolean;
  isProductSelected: boolean;
  selectedCategoryId: string;
  selectedProductId: string;
  selectedTreeId: string;

  @ViewChild('searchFormsRef') searchFormsRef: SearchFormsComponent;
  searchFormPopupVisible = false;
  initialSearchForm: SearchForm;
  refreshWithSearchForm: SearchForm;

  @ViewChild('catalogTreeSource') catalogTreeSource: CatalogTreeComponent;
  get treeListSource(): DxTreeListComponent { return this.catalogTreeSource?.treeList; }
  sourceCatalogs: Catalog[];
  selectedSourceCatalogId: string;
  treeSelectedRowKeysSource: any[] = [];

  @ViewChild('catalogTreeTarget') catalogTreeTarget: CatalogTreeComponent;
  get treeListTarget(): DxTreeListComponent { return this.catalogTreeTarget?.treeList; }
  targetCatalogs: Catalog[];
  selectedTargetCatalogId: string;

  lockSelection: boolean = false;
  sourceStateFilter: string[] = [];

  invoiceSetting: InvoiceSettingDto;
  classifaiSetting: ClassifaiSetting = new ClassifaiSetting();

  private preDragSelectedProducts: TreeItem[] = [];
  private autoSelectedFilterSignature: string = null;

  private _filterValue: any;
  get filterValue(): any { return this._filterValue; }
  set filterValue(value: any) {
    this._filterValue = value;
  }

  filterValueTarget: any;

  treeSelectedRowKeysTarget: any[] = [];

  transferProducts: boolean = true;
  transferCategories: boolean = true;

  modelMergestrategy: 'use-source' | 'keep-target' = "use-source";
  modelMergestrategyItems: any[];
  public productStates: string[] = new Array<string>();


  get selectedStates(): string[] {
    return this.modelService.catalogService.selectedStates;
  }

  get isOnboarding(): boolean {
    return this.modelService.loginService.hasAddonONBOARDING;
  }

  constructor(
    private http: HttpClient,
    public modelService: ModelService,
    public translate: TranslateService,
    private combineCatalogService: CombineCatalogService,
    private catalogService: CatalogService,
    private route: ActivatedRoute,
    public invoiceService: InvoiceService,
    private searchFormsService: SearchFormsService,
    public loginService: LoginService
  ) {
    this.onAddTarget = this.onAddTarget.bind(this);
    this.onClassifAi = this.onClassifAi.bind(this);
    this.startClassifAi = this.startClassifAi.bind(this);
    this.onDragStartSource = this.onDragStartSource.bind(this);
    this.onDragStartTarget = this.onDragStartTarget.bind(this);
    this.showAiDropZone = this.showAiDropZone.bind(this);
    this.hasSpid = this.hasSpid.bind(this);

    this.selectedTargetCatalogId = this.route.snapshot.paramMap.get('targetCatalogId');
    this.selectedSourceCatalogId = this.route.snapshot.paramMap.get('sourceCatalogId');
    this.lockSelection = this.route.snapshot.queryParamMap.get('lockSelection') === 'true';
    if (this.lockSelection) {
      this.transferProducts = true;
      this.transferCategories = false;
    }

    const stateFilter = this.route.snapshot.queryParamMap.get('sourceStateFilter');
    if (stateFilter) {
      this.sourceStateFilter = [stateFilter];
    }

  }

  ngOnInit(): void {
    this.searchFormsService.activeSearchForm = null;

    if (this.modelService.loginService.currentUser == null) {
      this.modelService.router.navigate(['/']);
      return;
    }
    this.invoiceService.GetInvoiceSetting(this.modelService.loginService.currentCustomer.id).subscribe(setting => {
      this.invoiceSetting = setting;
    });

    if (this.modelService.router.url === '/combineCatalogs') {
      this.modelService.systemService.currentNavigationTitle = this.translate.instant('Kataloge kombinieren');
    }

    this.modelService.loginService.customerService
      .getAllCustomerByUser(this.modelService.loginService.currentUser.id)
      .subscribe((customers: Customer[]) => {
        this.customers = customers;
        this.selectedCustomerId = this.modelService.loginService.currentUser.customerId;
      });

    this.modelService.catalogService
      .getCustomerProductStates(this.modelService.loginService.currentUser.customerId)
      .subscribe((states: ProductState[]) => {
        this.modelService.productStateService.productStates = new Array<string>();

        states.forEach((s) => {
          this.modelService.productStateService.productStates.push(s.name);
        });
      });

    this.txtAddCategory = this.translate.instant('Kategorie hinzufügen');
    this.txtDeleteCategory = this.translate.instant('Kategorie löschen');
    this.txtDeleteProd = this.translate.instant('Produkt löschen');
    this.txtLoading = this.translate.instant('Loading');

    this.txtNoFullCatalog = this.translate.instant('Ganzer Katalog kann nicht verschoben oder kopiert werden.');
    this.txtNoCategoriesOrCatalogInProd = this.translate.instant(
      'Kataloge und Kategorien können nicht in Produkte eingefügt werden.'
    );
    this.txtNoProdInChild = this.translate.instant('Produkte können nicht in Varianten eingefügt werden.');
    this.txtNoMasterInProd = this.translate.instant('Master-Produkte können nicht in Produkte eingefügt werden.');
    this.txtNoProdInSelf = this.translate.instant('Ein Produkt darf nicht auf sich selbst verschoben werden.');
    this.txtNoCatInSelf = this.translate.instant('Eine Kategorie darf nicht auf sich selbst verschoben werden.');
    this.txtExceedsMaxTotalCount = this.translate.instant('Über 100 Elemente markiert, ein Job wird für diese Aktion erstellt.')
    this.txtNoFilteredCatInCat = this.translate.instant(
      'Eine gefilterte Kategorie darf nicht auf eine andere Kategorie verschoben werden.'
    );
    this.txtNoMoveCategoriesRecursive = this.translate.instant(
      'Rekursiv selektierte Kategorien können nicht verschoben werden.'
    );
    this.txtNoMoveVarAlone = this.translate.instant('Varianten können nicht verschoben werden.');
    this.txtNoProdInCatalog = this.translate.instant('Produkte können nicht direkt im Katalog eingefügt werden.');
    this.txtNoCategoryInCatalog = this.translate.instant('Kategorien können im Übertragungsmodus "nur Produkte" nicht direkt im Katalog eingefügt oder verschoben werden.')
    this.txtNoRefForCatalog = this.translate.instant('Kataloge können nicht referenziert werden.');
    this.txtNoRefForVar = this.translate.instant('Varianten können nicht referenziert werden.');
    this.txtNoRefInProd = this.translate.instant('Referenzen können nicht in Produkte eingefügt werden.');
    this.txtOnlyProdCategoriesOrCatalog = this.translate.instant(
      'Bitte selektieren sie nur Produkte, nur Kategorien ODER den Katalog.'
    );
    this.txtOnlyMasterOrVar = this.translate.instant('Bitte selektieren sie nur Produkte ODER Varianten.');
    this.txtSourceEqualsTarget = this.translate.instant('Quelle und Ziel sind identisch.');
    this.txtNoMoveChildInCat = this.translate.instant(
      'Ein Kindprodukt darf nicht in eine Kategorie verschoben werden.'
    );

    this.txtCopy = this.translate.instant('copy');
    this.txtMove = this.translate.instant('move');
    this.txtReference = this.translate.instant('reference');

    this.operationsAll = [
      { id: 0, text: this.txtCopy },
      { id: 1, text: this.txtMove },
      { id: 2, text: this.txtReference }
    ];

    this.operationsNonVirtualSameCatalog = [
      { id: 1, text: this.txtMove },
      { id: 2, text: this.txtReference }
    ];

    this.operationsNonVirtualNotSameCatalog = [
      { id: 0, text: this.txtCopy },
      { id: 1, text: this.txtMove }
    ];

    this.operationsVirtual = [{ id: 2, text: this.txtReference }];

    this.resetOperations();

    this.populateSourceCatalogs();

    // erst setzten (und jedes mal NEU) wenn ein sourceCatalog gewählt wurde
    this.targetCatalogs = null;

    if (this.isOnboarding) {
      this.transferCategories = false;
      this.transferProducts = true;
      this.selectedCustomerId = this.modelService.loginService.currentCustomer.id;

      this.setSelectedOperation();
      this.selectedOperation = this.operationsNonVirtualNotSameCatalog[1];
    }

    this.modelMergestrategyItems = [{
      text: this.translate.instant("Daten aus dem Quellkatalog übernehmen"),
      mergeType: "use-source"
    },
      {text: this.translate.instant("Daten aus dem Zielkatalog beibehalten"), mergeType: "keep-target"}];
    this.modelMergestrategy = "use-source";
  }

  popupVisible = false;
  newCategoryName: string;
  validatorInstance: Validator;
  saveValidatorInstance(e) {
    this.validatorInstance = e.component;
  }

  async onAdd() {
    this.popupVisible = false;

    let customerId = this.selectedCustomerId;

    if (this.isCatalogSelected) {
      await this.addCategory(this.selectedTargetCatalogId, customerId, this.selectedTreeId, this.newCategoryName);
    }
    if (this.isCategorySelected) {
      await this.addCategory(this.selectedCategoryId, customerId, this.selectedTreeId, this.newCategoryName);
    }

    this.validatorInstance.reset();
  }

  // account selection
  _customers: Customer[];
  get customers(): Customer[] {
    return this._customers;
  }
  set customers(value: Customer[]) {
    this._customers = value;
  }

  _selectedCustomerId: string;
  get selectedCustomerId(): string {
    return this._selectedCustomerId;
  }
  set selectedCustomerId(value: string) {
    if (this._selectedCustomerId != value) {
      this._selectedCustomerId = value;
      this.populateTargetCatalogs();
    }
  }

  async onContentReadySource(e: any) {
    if (this.selectedSourceCatalogId) {
      await e.component.expandRow(this.selectedSourceCatalogId);
    }

    const filterActive = !!(this._filterValue?.trim() || this.catalogTreeSource?.activeSearchFormFilter);
    if (!filterActive) {
      this.autoSelectedFilterSignature = null;
      return;
    }

    const signature = this.getSourceFilterSignature();
    if (signature === this.autoSelectedFilterSignature) {
      return;
    }

    const productKeys = this.collectProductKeys(e.component);
    if (productKeys.length === 0) {
      return;
    }

    this.autoSelectedFilterSignature = signature;
    this.treeSelectedRowKeysSource = productKeys;
  }

  private collectProductKeys(treeInstance: any): any[] {
    const keys: any[] = [];
    treeInstance.forEachNode((node: any) => {
      if (node.data?.type === 'pro') {
        keys.push(node.key);
      }
    });
    return keys;
  }

  private getSourceFilterSignature(): string {
    return JSON.stringify({
      catalogId: this.selectedSourceCatalogId ?? null,
      filter: this._filterValue ?? '',
      searchFormId: this.catalogTreeSource?.activeSearchFormFilter?.id ?? null,
      states: this.selectedStates ?? []
    });
  }

  async onContentReadyTarget(e: any) {
    if (this.selectedTargetCatalogId) {
      await e.component.expandRow(this.selectedTargetCatalogId);
    }
  }

  sourceSelected(event) {
    // ein katalog wurde gelöscht
    if (event == null || event.selectedItem == null) {
      this.selectedSourceCatalogId = null;

      this.populateSourceCatalogs(); // ein katalog wurde gelöscht ==> muss hier 'raus, neu laden
      this.populateTargetCatalogs(); // ein katalog wurde gelöscht ==> muss hier 'raus, neu laden

      this.resetOperations();

      return;
    }

    this.selectedSourceCatalogId = event.selectedItem.id;
    this.catalogService.selectedCatalogId = this.selectedSourceCatalogId;

    this.populateTargetCatalogs();

    this.setSelectedOperation();
  }

  populateSourceCatalogs() {
    this.modelService.catalogService
      .getCatalogs(this.modelService.loginService.currentUser.customerId)
      .subscribe((result: Catalog[]) => {
        this.sourceCatalogs = result.filter((c) => !c.isVirtual);
      });
  }


  toggleSearchFormPopup(searchForm?: SearchForm) {
    this.initialSearchForm = searchForm ? { ...searchForm } : null;
    this.searchFormPopupVisible = true;
  }

  onSearchFormPopupVisibleChange(visible: boolean) {
    this.searchFormPopupVisible = visible;
  }

  onSearchFormSaved(searchForm: SearchForm) {
    this.refreshWithSearchForm = { ...searchForm };
    this.searchFormPopupVisible = false;
  }

  onSaveSearchForm = () => this.searchFormsRef?.onSave();
  onCancelSearchForm = () => this.searchFormsRef?.onCancel();

  targetSelected(event) {
    // sourceCatalog wurde auf den gleichen wie targetCatalog gesetzt, dadurch wurde targetCatalog aus der datasource entfernt <== obsolet?
    if (event.selectedItem == null) {
      this.selectedTargetCatalogId = null;
      this.catalogService.selectedTargetCatalogId = null;
    } else {
      this.selectedTargetCatalogId = event.selectedItem.id;
      this.catalogService.selectedTargetCatalogId = this.selectedTargetCatalogId;
      this.loadSpidsForTarget();
    }

    this.isTargetCatalogVirtual = false;
    let catalog = this.targetCatalogs.filter((c) => c.id == this.selectedTargetCatalogId)[0];
    if (catalog != null && catalog.isVirtual) {
      this.isTargetCatalogVirtual = true;
    }

    this.setSelectedOperation();
  }

  populateTargetCatalogs() {
    this.modelService.catalogService.getCatalogs(this.selectedCustomerId).subscribe((result: Catalog[]) => {
      //let allTargetCatalogs = result;
      //this.targetCatalogs = allTargetCatalogs.filter(c => c.id != this.selectedSourceCatalogId);
      this.targetCatalogs = result;
      if (this.modelService?.loginService?.currentUser?.customerId != this.selectedCustomerId) {
        // virtuelle Kataloge soll es nicht Account-Übergreifend geben (TR)
        this.targetCatalogs = result.filter((t) => t.isVirtual == false);
      }

      if (this.isOnboarding) {
        this.targetCatalogs = this.targetCatalogs.filter((x) => x.isDemoCatalog);
      }

      if (this.targetCatalogs.length == 1) {
        this.selectedTargetCatalogId = this.targetCatalogs[0].id;
        this.catalogService.selectedTargetCatalogId = this.selectedTargetCatalogId;
      }
    });
  }

  showAiDropZone(): boolean {
    if (!this.selectedTargetCatalogId) {
      return false;
    }

    if (!this.modelService.loginService.hasAddonKI_CLASSIFAI) {
      return false;
    }

    return true;
  }
  brainData = [
    {
      id: 'brainRoot',
      parentId: 0,      // entspricht rootValue="0"
      title: 'Brain Node'
    }
  ];

  loadSpidsForTarget() {
    if (!this.selectedTargetCatalogId) {
      return;
    }

    this.modelService.catalogService
      .getSpidsInCatalog(this.selectedTargetCatalogId, this.selectedCustomerId)
      .subscribe((response: Array<string>) => {
        this.existingSpids = response;
      });
  }

  existingSpids = new Array<string>();

  hasSpid(spid): boolean {
    let s = this.existingSpids.filter((e) => e == spid);
    if (s.length == 0) {
      return false;
    }
    return true;
  }

  async onAddTarget(e) {
    if(!this.transferCategories && !this.transferProducts) {
      this.modelService.systemService.notify(new Message(this.translate.instant("SelectMinimumOneTransfer")), 2500);
      return;
    }
    switch (this.selectedOperation.id) {
      case 0:
        await this.processCopy(e, false);
        break;
      case 1:
        await this.processMove(e, false);
        break;
      case 2:
        this.processReference(e, false);
        break;
      default:
        return;
    }

    this.treeSelectedRowKeysSource = [];
  }

  confirmVisible: boolean = false;
  classifAiEvent = null;

  onClassifAi(e) {
    this.classifAiEvent = e;
    this.confirmVisible = true;
    this.classifaiSetting.directMode = true;
    this.classifaiSetting.fillEmptyFeatureAutomatically = false;
    this.classifaiSetting.onlyNewProducts = true;
    this.invoiceService.GetInvoiceSetting(this.modelService.loginService.currentCustomer.id).subscribe(setting => {
      this.invoiceSetting = setting;
    });
  }

  async startClassifAi() {
    this.confirmVisible = false;
    if(!this.transferCategories && !this.transferProducts) {
      this.modelService.systemService.notify(new Message(this.translate.instant("SelectMinimumOneTransfer")), 2500);
      return;
    }
    switch (this.selectedOperation.id) {
      case 0:
        await this.processCopy(this.classifAiEvent, true);
        break;
      case 1:
        await this.processMove(this.classifAiEvent, true);
        break;
      case 2:
        this.processReference(this.classifAiEvent, true);
        break;
      default:
        return;
    }

    this.treeSelectedRowKeysSource = [];
  }


  onDragStartSource(e): void {
    this.captureExplicitProductSelection();
  };

  onDragStartTarget(e) {
    e.cancel = true;
  }

  private captureExplicitProductSelection(): void {
    if (this.isSearchActive) {
      this.preDragSelectedProducts = [];
      return;
    }
    this.preDragSelectedProducts = (this.treeListSource.instance.getSelectedRowsData() as TreeItem[])
      .filter(d => d.type === 'pro');
  }

  private allProductsExplicitlyPreSelected(products: TreeItem[]): boolean {
    const keys = new Set(this.preDragSelectedProducts.map(p => p.treeElementId.toString()));
    return products.length > 0 && products.every(p => keys.has(p.treeElementId.toString()));
  }

  private includeMastersOfSelectedVariants(selectedData: TreeItem[]): TreeItem[] {
    const presentKeys = new Set(selectedData.map(t => t.treeElementId.toString()));
    const missingMasters: TreeItem[] = [];

    for (const variant of selectedData.filter(t => t.isChild)) {
      const masterKey = variant.parent?.toString();
      if (!masterKey || presentKeys.has(masterKey)) {
        continue;
      }
      const masterNode = this.treeListSource.instance.getNodeByKey(masterKey);
      if (masterNode?.data) {
        presentKeys.add(masterKey);
        missingMasters.push(masterNode.data);
      }
    }

    return missingMasters.length ? [...selectedData, ...missingMasters] : selectedData;
  }

  private applyMasterVariantSelection(selectedData: TreeItem[]): TreeItem[] {
    const preSelectedVariants = this.preDragSelectedProducts.filter(p => p.isChild);
    const selectedMasterKeys = new Set(
      selectedData.filter(t => t.hasChilds).map(t => t.treeElementId.toString())
    );
    const restrictedMasterKeys = new Set(
      preSelectedVariants
        .map(v => v.parent?.toString())
        .filter((key): key is string => !!key && selectedMasterKeys.has(key))
    );
    if (restrictedMasterKeys.size === 0) {
      return selectedData;
    }

    const preSelectedKeys = new Set(preSelectedVariants.map(v => v.treeElementId.toString()));
    const belongsToRestrictedMaster = (item: TreeItem) =>
      item.isChild && !!item.parent && restrictedMasterKeys.has(item.parent.toString());

    const kept = selectedData.filter(item =>
      !belongsToRestrictedMaster(item) || preSelectedKeys.has(item.treeElementId.toString())
    );
    const keptKeys = new Set(kept.map(k => k.treeElementId.toString()));
    const missingVariants = preSelectedVariants.filter(v =>
      belongsToRestrictedMaster(v) && !keptKeys.has(v.treeElementId.toString())
    );

    return [...kept, ...missingVariants];
  }

  async processCopy(e, isClassifAi: boolean) {
    this.treeListSource.instance.selectRows(e.itemData.treeElementId, true);
    await this.copyMany(e, isClassifAi);
  }

  async processMove(e, isClassifAi: boolean) {
    this.treeListSource.instance.selectRows(e.itemData.treeElementId, true);
    await this.moveMany(e, isClassifAi);
  }

  processReference(e, isClassifAi: boolean) {
    this.treeListSource.instance.selectRows(e.itemData.treeElementId, true);
    this.referenceMany(e, isClassifAi);
  }

  async copyMany(e, isClassifAi: boolean) {
    let sourceSelectedData: TreeItem[] = this.deduplicateSourceSelection(this.treeListSource.instance.getSelectedRowsData());
    sourceSelectedData = this.applyMasterVariantSelection(sourceSelectedData);

    let sourceCatalogs = sourceSelectedData.filter((t) => t.type == 'cat');
    let sourceCategories = sourceSelectedData.filter((t) => t.type == 'grp');
    let sourceProducts = sourceSelectedData.filter((t) => t.type == 'pro');
    let masters = sourceProducts.filter((p) => p.hasChilds);
    let childs = sourceProducts.filter((p) => p.isChild);

    if (!isClassifAi) {
      if (sourceCatalogs.length > 0) {
        this.modelService.systemService.notify(new Message(this.txtNoFullCatalog), 2500);
        return;
      }
      if (
        (sourceCatalogs.length > 0 && sourceCategories.length > 0) ||
        (sourceCatalogs.length > 0 && sourceProducts.length > 0) ||
        (sourceCategories.length > 0 && sourceProducts.length > 0 && !this.allProductsExplicitlyPreSelected(sourceProducts))
      ) {
        this.modelService.systemService.notify(new Message(this.txtOnlyProdCategoriesOrCatalog), 2500);
        return;
      }

      const masterKeys = new Set(masters.map((m) => m.treeElementId.toString()));
      const unrelatedChilds = childs.filter((c) => !(c.parent && masterKeys.has(c.parent.toString())));
      if (masters.length > 0 && unrelatedChilds.length > 0) {
        this.modelService.systemService.notify(new Message(this.txtOnlyMasterOrVar), 2500);
        return;
      }
    }
    let rows = this.treeListTarget.instance.getVisibleRows();
    let targetItem = rows[e.toIndex].node.data;

    if (targetItem.type === 'grp') {
      sourceSelectedData = this.includeMastersOfSelectedVariants(sourceSelectedData);
    }

    if (!isClassifAi) {
      if (targetItem.type == 'pro') {
        if (sourceProducts.length > 0 && masters.length > 0) {
          // verboten:
          // master     in prod (master)
          // master     in prod (child)
          this.modelService.systemService.notify(new Message(this.txtNoMasterInProd), 2500);
          return;
        }
        if (sourceCatalogs.length > 0 || sourceCategories.length > 0) {
          // verboten:
          // katalog    in prod
          // kategorie  in prod
          this.modelService.systemService.notify(new Message(this.txtNoCategoriesOrCatalogInProd), 2500);
          return;
        }
        if (targetItem.isChild) {
          this.modelService.systemService.notify(new Message(this.txtNoProdInChild), 2500);
          return;
        }

        let dialogResult = await confirm(
          this.translate.instant('ConfirmVariantCopyText'),
          this.translate.instant('Variante erstellen')
        );
        if (!dialogResult) {
          return;
        }
      }

      if (targetItem.type == 'cat') {
        if (sourceProducts.length > 0) {
          // verboten:
          // prod         in katalog
          this.modelService.systemService.notify(new Message(this.txtNoProdInCatalog), 2500);
          return;
        }
        else if (this.transferProducts && !this.transferCategories) {
          this.modelService.systemService.notify(new Message(this.txtNoCategoryInCatalog), 2500);
          return;
        }
      }
    }

    let startJob = this.checkIfMaxTransferCountExceeded(sourceSelectedData);

    if (isClassifAi) {
      startJob = true;
    }

    let model = new TransferCatalogItem();
    model.classifaiSetting = this.classifaiSetting;
    model.isClassifAi = isClassifAi;
    model.targetItem = new CatalogItem();
    model.targetItem.CatalogId = this.selectedTargetCatalogId;
    model.targetItem.CustomerId = this.selectedCustomerId;

    switch (targetItem.type) {
      case 'pro':
        model.targetItem.ProductId = targetItem.id.toString();
        model.targetItem.CategoryId = targetItem.treeElementId.toString().split('_')[1];
        break;
      case 'grp':
        model.targetItem.CategoryId = targetItem.id.toString();
        break;
    }

    model.itemsToTransfer = new Array<CatalogItem>();
    sourceSelectedData.forEach((sourceItem) => {
      let item = new CatalogItem();
      item.CustomerId = this.modelService.loginService.currentUser.customerId;
      item.CatalogId = this.selectedSourceCatalogId;
      switch (sourceItem.type) {
        case 'pro':
          item.ProductId = sourceItem.id.toString();
          item.CategoryId = sourceItem.treeElementId.toString().split('_')[1];
          break;
        case 'grp':
          item.CategoryId = sourceItem.id.toString();
          break;
      }

      model.itemsToTransfer.push(item);
    });

    this.applySearchFilter(model);

    let response: Promise<StringResponse>;

    if(this.transferCategories && this.transferProducts) {
      model.mergeStrategy = this.modelMergestrategy;
      response = this.combineCatalogService.copyItems(model, startJob);
    } else if(this.transferCategories) {
      response = this.combineCatalogService.copyCategories(model, startJob);
    } else if(this.transferProducts) {
      if (sourceSelectedData.some((t) => t.hasChilds)) {
        model.mergeStrategy = this.modelMergestrategy;
        response = this.combineCatalogService.copyProducts(model, startJob);
      } else {
      const toUseSource: CatalogItem[] = [];
      const toKeepTarget: CatalogItem[] = [];
      const noConflict: CatalogItem[] = [];

      for (const sourceItem of sourceSelectedData) {
        if (sourceItem.type !== 'pro') {
          model.mergeStrategy = this.modelMergestrategy;
          response = this.combineCatalogService.copyProducts(model, startJob);
          break;
        }
        const supplierPid = sourceItem.supplierPid;
        const productName = sourceItem.text;

        let item = new CatalogItem();
        item.CustomerId = this.modelService.loginService.currentUser.customerId;
        item.CatalogId = this.selectedSourceCatalogId;
        item.ProductId = sourceItem.id.toString();
        item.CategoryId = sourceItem.treeElementId.toString().split('_')[1];

        if (supplierPid && this.hasSpid(supplierPid)) {
          const choice = this.modelMergestrategy;
          if (choice === 'use-source') {
            toUseSource.push(item);
          } else if (choice === 'keep-target') {
            toKeepTarget.push(item);
          }
        } else {
          noConflict.push(item);
        }
      }

      const buildModel = (items: CatalogItem[], merge?: 'use-source' | 'keep-target') => {
        const m = new TransferCatalogItem();
        m.classifaiSetting = this.classifaiSetting;
        m.isClassifAi = isClassifAi;
        m.targetItem = model.targetItem;
        m.itemsToTransfer = items;
        (m as any).mergeStrategy = merge;
        this.applySearchFilter(m);
        return m;
      };

      const calls: Array<Promise<StringResponse>> = [];
      if (toKeepTarget.length) {
        calls.push(this.combineCatalogService.copyProducts(buildModel(toKeepTarget, 'keep-target'), startJob));
      }
      if (toUseSource.length) {
        calls.push(this.combineCatalogService.copyProducts(buildModel(toUseSource, 'use-source'), startJob));
      }
      if (noConflict.length) {
        calls.push(this.combineCatalogService.copyProducts(buildModel(noConflict, undefined), startJob));
      }

      response = Promise.all(calls).then(() => new StringResponse());
      }
    }

    this.handleTransferResponse(response, startJob, isClassifAi, targetItem, model, false);

  }

  async moveMany(e, isClassifAi: boolean) {
    let sourceSelectedData: TreeItem[] = this.deduplicateSourceSelection(this.treeListSource.instance.getSelectedRowsData());

    let sourceCatalogs = sourceSelectedData.filter((t) => t.type == 'cat');
    let sourceCategories = sourceSelectedData.filter((t) => t.type == 'grp');
    let sourceProducts = sourceSelectedData.filter((t) => t.type == 'pro');
    let masters = sourceProducts.filter((p) => p.hasChilds);
    let childs = sourceProducts.filter((p) => p.isChild);
    if (!isClassifAi) {
      if (sourceCatalogs.length > 0) {
        this.modelService.systemService.notify(new Message(this.txtNoFullCatalog), 2500);
        return;
      }
      if (
        (sourceCatalogs.length > 0 && sourceCategories.length > 0) ||
        (sourceCatalogs.length > 0 && sourceProducts.length > 0) ||
        (sourceCategories.length > 0 && sourceProducts.length > 0 && !this.allProductsExplicitlyPreSelected(sourceProducts))
      ) {
        this.modelService.systemService.notify(new Message(this.txtOnlyProdCategoriesOrCatalog), 2500);
        return;
      }

      if (masters.length > 0 && childs.length > 0) {
        this.modelService.systemService.notify(new Message(this.txtOnlyMasterOrVar), 2500);
        return;
      }
    }
    let rows = this.treeListTarget.instance.getVisibleRows();
    let targetItem = rows[e.toIndex].node.data;
    if (!isClassifAi) {
      if (targetItem.type == 'pro') {
        if (sourceProducts.length > 0 && sourceProducts.every((x) => x.id === targetItem.id)) {
          // verboten:
          // target darf nicht selbes Produkt sein wie source
          this.modelService.systemService.notify(new Message(this.txtNoProdInSelf), 2500);
          return;
        }

        if (sourceProducts.length > 0 && masters.length > 0) {
          // verboten:
          // master     in prod (master)
          // master     in prod (child)
          this.modelService.systemService.notify(new Message(this.txtNoMasterInProd), 2500);
          return;
        }
        if (sourceCatalogs.length > 0 || sourceCategories.length > 0) {
          // verboten:
          // katalog    in prod
          // kategorie  in prod
          this.modelService.systemService.notify(new Message(this.txtNoCategoriesOrCatalogInProd), 2500);
          return;
        }
        if (targetItem.isChild) {
          this.modelService.systemService.notify(new Message(this.txtNoProdInChild), 2500);
          return;
        }
      }

      if (childs.length > 0) {
        let dialogResult = await confirm(
          this.translate.instant('ConfirmVariantMoveText'),
          this.translate.instant('Variante erstellen')
        );
        if (!dialogResult) {
          return;
        }
      }


      if (targetItem.type == 'cat') {
        if (sourceProducts.length > 0) {
          // verboten:
          // prod         in katalog
          this.modelService.systemService.notify(new Message(this.txtNoProdInCatalog), 2500);
          return;
        }
        else if (this.transferProducts && !this.transferCategories) {
          this.modelService.systemService.notify(new Message(this.txtNoCategoryInCatalog), 2500);
          return;
        }
      }

      if (targetItem.type === 'grp') {
        if (sourceCategories.length > 0 && (this.selectedStates.length > 0 || this.filterValue?.trim())) {
          // verboten:
          // source darf keine gefilterte Kategorie sein
          this.modelService.systemService.notify(new Message(this.txtNoFilteredCatInCat), 2500);
          return;
        }

        if (sourceProducts.length > 0 && sourceProducts.some((x) => x.isChild)) {
          // verboten:
          // source darf kein gefiltertes Kindprodukt sein.
          this.modelService.systemService.notify(new Message(this.txtNoMoveChildInCat), 2500);
          return;
        }

        if (sourceCategories.length > 0 && sourceCategories.every((x) => x.id === targetItem.id)) {
          // verboten:
          // target darf nicht selbe Kategorie sein wie source
          this.modelService.systemService.notify(new Message(this.txtNoCatInSelf), 2500);
          return;
        }

        if (this.isOnboarding && targetItem.categoryCount > 0) {
          this.modelService.systemService.notify(
            new Message(this.translate.instant('Artikel können nur in die unterste Kategorie verschoben werden')),
            2500
          );
          return;
        }
      }
    }

    let startJob = this.checkIfMaxTransferCountExceeded(sourceSelectedData);

    if (isClassifAi) {
      startJob = true;
    }
    let model = new TransferCatalogItem();
    model.classifaiSetting = this.classifaiSetting;
    model.isClassifAi = isClassifAi;
    model.targetItem = new CatalogItem();
    model.targetItem.CatalogId = this.selectedTargetCatalogId;
    model.targetItem.CustomerId = this.selectedCustomerId;
    switch (targetItem.type) {
      case 'pro':
        model.targetItem.ProductId = targetItem.id.toString();
        model.targetItem.CategoryId = targetItem.treeElementId.toString().split('_')[1];
        break;
      case 'grp':
        model.targetItem.CategoryId = targetItem.id.toString();
        break;
    }

    model.itemsToTransfer = new Array<CatalogItem>();
    sourceSelectedData.forEach((sourceItem) => {
      let item = new CatalogItem();
      item.CustomerId = this.modelService.loginService.currentUser.customerId;
      item.CatalogId = this.selectedSourceCatalogId;
      switch (sourceItem.type) {
        case 'pro':
          item.ProductId = sourceItem.id.toString();
          item.CategoryId = sourceItem.treeElementId.toString().split('_')[1];
          break;
        case 'grp':
          item.CategoryId = sourceItem.id.toString();
          break;
      }

      model.itemsToTransfer.push(item);
    });

    this.applySearchFilter(model);

    let response: Promise<StringResponse>;
    if(this.transferProducts && this.transferCategories) {
      const choice = this.modelMergestrategy;
      (model as any).mergeStrategy = choice;
      response = this.combineCatalogService.moveItems(model, startJob);
    } else if(this.transferCategories) {
      let message = this.translate.instant('OnlyCategoriesNotAllowMoving');
      this.modelService.systemService.notify(new Message(message), 2500);
      return;
    } else if(this.transferProducts) {
      const toUseSource: CatalogItem[] = [];
      const toKeepTarget: CatalogItem[] = [];
      const noConflict: CatalogItem[] = [];

      for (const sourceItem of sourceSelectedData) {
        let item = new CatalogItem();
        item.CustomerId = this.modelService.loginService.currentUser.customerId;
        item.CatalogId = this.selectedSourceCatalogId;
        switch (sourceItem.type) {
          case 'pro':
            item.ProductId = sourceItem.id.toString();
            item.CategoryId = sourceItem.treeElementId.toString().split('_')[1];
            break;
          case 'grp':
            item.CategoryId = sourceItem.id.toString();
            break;
        }

        if (sourceItem.type !== 'pro') {
          noConflict.push(item);
          continue;
        }

        const supplierPid = sourceItem.supplierPid;
        if (supplierPid && this.hasSpid(supplierPid)) {
          const choice = this.modelMergestrategy;
          if (choice === 'use-source') {
            toUseSource.push(item);
          } else if (choice === 'keep-target') {
            toKeepTarget.push(item);
          }
        } else {
          noConflict.push(item);
        }
      }

      const buildModel = (items: CatalogItem[], merge?: 'use-source' | 'keep-target') => {
        const m = new TransferCatalogItem();
        m.classifaiSetting = this.classifaiSetting;
        m.isClassifAi = isClassifAi;
        m.targetItem = model.targetItem;
        m.itemsToTransfer = items;
        (m as any).mergeStrategy = merge;
        this.applySearchFilter(m);
        return m;
      };

      const calls: Array<Promise<StringResponse>> = [];
      if (toKeepTarget.length) {
        calls.push(this.combineCatalogService.moveProducts(buildModel(toKeepTarget, 'keep-target'), startJob));
      }
      if (toUseSource.length) {
        calls.push(this.combineCatalogService.moveProducts(buildModel(toUseSource, 'use-source'), startJob));
      }
      if (noConflict.length) {
        calls.push(this.combineCatalogService.moveProducts(buildModel(noConflict, undefined), startJob));
      }

      response = Promise.all(calls).then(() => new StringResponse());
    }

    this.handleTransferResponse(response, startJob, isClassifAi, targetItem, model);
  }

  referenceMany(e, isClassifAi: boolean) {
    let sourceSelectedData: TreeItem[] = this.deduplicateSourceSelection(this.treeListSource.instance.getSelectedRowsData());

    let sourceCatalogs = sourceSelectedData.filter((t) => t.type == 'cat');
    let sourceCategories = sourceSelectedData.filter((t) => t.type == 'grp');
    let sourceProducts = sourceSelectedData.filter((t) => t.type == 'pro');
    let masters = sourceProducts.filter((p) => p.hasChilds);
    let childs = sourceProducts.filter((p) => p.isChild);

    let targetCatalog = this.targetCatalogs.find((x) => x.id == this.selectedTargetCatalogId);
    let sourceCatalog = this.sourceCatalogs.find((x) => x.id == this.selectedSourceCatalogId);

    if (targetCatalog.isVirtual && (!sourceCatalog.catalogId || !sourceCatalog.isActivId)) {
      this.modelService.systemService.notify(new Message(this.translate.instant('CatalogIdRequired')), 2500);
      return;
    }

    if (
      (sourceCatalogs.length > 0 && sourceCategories.length > 0) ||
      (sourceCatalogs.length > 0 && sourceProducts.length > 0) ||
      (sourceCategories.length > 0 && sourceProducts.length > 0 && !this.allProductsExplicitlyPreSelected(sourceProducts))
    ) {
      this.modelService.systemService.notify(new Message(this.txtOnlyProdCategoriesOrCatalog), 2500);
      return;
    }

    if (masters.length > 0 && childs.length > 0) {
      this.modelService.systemService.notify(new Message(this.txtOnlyMasterOrVar), 2500);
      return;
    }

    let rows = this.treeListTarget.instance.getVisibleRows();
    let targetItem = rows[e.toIndex].node.data;

    if (targetItem.type == 'pro') {
      if (sourceProducts.length > 0) {
        // verboten:
        // prod       in prod
        this.modelService.systemService.notify(new Message(this.txtNoRefInProd), 2500);
        return;
      }
    }

    if (sourceCatalogs.length > 0) {
      // verboten:
      // katalog referenzieren
      this.modelService.systemService.notify(new Message(this.txtNoRefForCatalog), 2500);
      return;
    }

    if (targetItem.type == 'cat') {
      if (sourceProducts.length > 0 || (this.transferProducts && !this.transferCategories)) {
        // verboten:
        // prod         in katalog
        this.modelService.systemService.notify(new Message(this.txtNoProdInCatalog), 2500);
        return;
      }
    }

    if (childs.length > 0) {
      // verboten:
      // variante referenzieren
      this.modelService.systemService.notify(new Message(this.txtNoRefForVar), 2500);
      return;
    }


    let startJob = this.checkIfMaxTransferCountExceeded(sourceSelectedData);
    if (isClassifAi) {
      startJob = true;
    }
    let model = new TransferCatalogItem();
    model.isClassifAi = isClassifAi;
    model.classifaiSetting = this.classifaiSetting;
    model.targetItem = new CatalogItem();
    model.targetItem.CatalogId = this.selectedTargetCatalogId;
    model.targetItem.CustomerId = this.selectedCustomerId;
    switch (targetItem.type) {
      case 'pro':
        model.targetItem.ProductId = targetItem.id.toString();
        model.targetItem.CategoryId = targetItem.treeElementId.toString().split('_')[1];
        break;
      case 'grp':
        model.targetItem.CategoryId = targetItem.id.toString();
        break;
    }

    model.itemsToTransfer = new Array<CatalogItem>();
    sourceSelectedData.forEach((sourceItem) => {
      let item = new CatalogItem();
      item.CustomerId = this.modelService.loginService.currentUser.customerId;
      item.CatalogId = this.selectedSourceCatalogId;
      switch (sourceItem.type) {
        case 'pro':
          item.ProductId = sourceItem.id.toString();
          item.CategoryId = sourceItem.treeElementId.toString().split('_')[1];
          break;
        case 'grp':
          item.CategoryId = sourceItem.id.toString();
          break;
      }

      model.itemsToTransfer.push(item);
    });

    this.applySearchFilter(model);

    let response: Promise<StringResponse>;
    if(this.transferProducts && this.transferCategories) {
      response = this.combineCatalogService.referenceItems(model, startJob);
    } else if(this.transferCategories) {
      response = this.combineCatalogService.copyCategories(model, startJob);
    } else if(this.transferProducts) {
      response = this.combineCatalogService.referenceProducts(model, startJob);
    }

    this.handleTransferResponse(response, startJob, isClassifAi, targetItem, model);
  }

  private handleTransferResponse(
    response: Promise<StringResponse>,
    startJob: boolean,
    isClassifAi: boolean,
    targetItem: any,
    model: TransferCatalogItem,
    refreshSource: boolean = true
  ) {
    this.treeListTarget.instance.beginCustomLoading(this.txtLoading);
    response.then(
      () => {
        this.treeListTarget.instance.endCustomLoading();

        if (startJob && !isClassifAi) {
          this.modelService.systemService.notify(new Message(this.txtExceedsMaxTotalCount), 2500);
          return;
        }
        if (isClassifAi) {
          this.modelService.systemService.notify(new Message(this.translate.instant('Die KI Klassifizierung wird per Job durchgeführt')), 2500);
          return;
        }

        this.modelService.catalogService
          .getSpidsInCatalog(this.selectedTargetCatalogId, this.selectedCustomerId)
          .subscribe((arr: Array<string>) => {
            this.existingSpids = arr;
          });

        this.refreshTargetTree(targetItem.id);

        if (refreshSource) {
          if (this.selectedSourceCatalogId == this.selectedTargetCatalogId) {
            this.refreshSourceTree(targetItem.id);
          } else {
            this.refreshSourceTree(model.itemsToTransfer[0].CategoryId);
          }
        }
      },
      (error) => {
        this.treeListTarget.instance.endCustomLoading();
      }
    );
  }


  checkIfMaxTransferCountExceeded(sourceSelectedData: TreeItem[]): boolean {
    let parentIds = sourceSelectedData.map(item => item.parent);
    let filteredData = sourceSelectedData.filter(item => !parentIds.includes(item.treeElementId.toString()));
    let totalCount = 0;
    for (var i = 0; i < filteredData.length; i++) {
      if(this.transferProducts && this.transferCategories) {
        totalCount += filteredData[i].productCount;
        totalCount += filteredData[i].categoryCount;
      } else if(this.transferCategories) {
        totalCount += filteredData[i].categoryCount;
      } else if(this.transferProducts) {
        totalCount += filteredData[i].productCount;
      }
    }

    return totalCount > 100;
  }

  refreshTargetTree(parentId: string) {
    let that = this;

    this.treeListTarget.instance.refresh().then(function () {
      that.treeListTarget.instance.expandRow(parentId);
    });
  }

  refreshSourceTree(parentId: string) {
    let that = this;

    this.treeListSource.instance.refresh().then(function () {
      that.treeListSource.instance.expandRow(parentId);
    });
  }

  // brauchen wir nicht
  // abgekupfert aus: \Pim\ClientApp\src\app\catalog\browse\browse.component.ts
  onRowClick(e) {
    //if (e.event.target !== undefined && e.event.target.localName != "span") {
    //  if ((e.event.srcElement.localName == "img" && e.event.srcElement.className == "flag") ||
    //    e.event.srcElement.localName == "dx-select-box"
    //  ) {
    //    return;
    //  }
    //  if ((e.event.srcElement.localName == "i" && e.event.srcElement.className == "dx-icon dx-icon-menu") ||
    //    (e.event.srcElement.localName == "div" && e.event.srcElement.className == "dx-button-content")
    //  ) {
    //    return;
    //  }
    //}
  }

  // abgekupfert aus: \Pim\ClientApp\src\app\catalog\browse\browse.component.ts
  onSelectionChangedTarget(e) {
    if (e.selectedRowsData.length > 0) {
      let selectedRowData = e.selectedRowsData[0];
      this.openItem(selectedRowData.type, selectedRowData.id, selectedRowData.isChild);
    }
  }

  // abgekupfert aus: \Pim\ClientApp\src\app\catalog\browse\browse.component.ts
  private openItem(type: string, id: string, isChild: boolean) {
    this.isCategorySelected = false;
    this.isCatalogSelected = false;
    this.isProductSelected = false;

    switch (type) {
      case 'cat':
        this.isCatalogSelected = true;
        this.menuItems = [{ id: 2, text: this.txtAddCategory, icon: 'glyphicon glyphicon-plus', beginGroup: false }];
        break;

      case 'grp':
        this.isCategorySelected = true;
        this.selectedCategoryId = id;
        if (this.isOnboarding) {
          this.menuItems = [];
          break;
        }
        this.menuItems = [
          { id: 2, text: this.txtAddCategory, icon: 'glyphicon glyphicon-plus', beginGroup: false },
          { id: 7, text: this.txtDeleteCategory, icon: 'glyphicon glyphicon-trash', beginGroup: true }
        ];
        break;

      case 'pro':
        this.isProductSelected = true;
        this.selectedProductId = id;
        this.menuItems = [];
        if (!isChild || (isChild && !this.isTargetCatalogVirtual)) {
          this.menuItems = [{ id: 0, text: this.txtDeleteProd, icon: 'glyphicon glyphicon-trash', beginGroup: false }];
        }
        break;
    }
  }

  // abgekupfert aus: \Pim\ClientApp\src\app\catalog\browse\browse.component.ts
  onContextMenuShowing(e, item) {
    let key = item.key;

    if (key != '' && key) {
      let keys = new Array<string>();
      keys.push(key);
      let result = this.treeListTarget.instance.selectRows(keys, false);
    }
  }

  // abgekupfert aus: \Pim\ClientApp\src\app\catalog\browse\browse.component.ts
  async itemClick(e, itemClickData) {
    this.selectedTreeId = itemClickData.data.treeElementId;

    let txtYes = '';
    let txtNo = '';
    let txtMsg = '';
    let txtTitle = '';
    let myDialog: any;

    switch (e.itemData.id) {
      // Kategorie hinzufügen
      case 2:
        this.popupVisible = true;

        break;

      // Kategorie löschen
      case 7:
        txtYes = this.translate.instant('Ja');
        txtNo = this.translate.instant('Nein');
        txtMsg = this.translate.instant('Soll die Kategorie wirklich gelöscht werden?');
        txtTitle = this.translate.instant('Wirklich löschen?');

        myDialog = custom({
          title: txtTitle,
          messageHtml: txtMsg,
          buttons: [
            {
              text: txtYes,
              onClick: (e) => {
                return { buttonText: true };
              }
            },
            {
              text: txtNo,
              onClick: (e) => {
                return { buttonText: false };
              }
            }
          ]
        });
        myDialog.show().then((dialogResult) => {
          if (dialogResult.buttonText == true) {
            this.http
              .delete('api/category/DeleteCategory/' + this.selectedCustomerId + '/' + this.selectedTreeId)
              .subscribe(() => {
                this.treeListTarget.instance.refresh();

                if (this.selectedSourceCatalogId == this.selectedTargetCatalogId) {
                  this.treeListSource.instance.refresh();
                }

                this.modelService.catalogService
                  .getSpidsInCatalog(this.selectedTargetCatalogId, this.selectedCustomerId)
                  .subscribe((response: Array<string>) => {
                    this.existingSpids = response;
                  });
              });
          }
        });

        break;

      // Produkt löschen
      case 0:
        txtYes = this.translate.instant('Ja');
        txtNo = this.translate.instant('Nein');
        txtMsg = this.translate.instant('Soll das Produkt wirklich gelöscht werden?');
        txtTitle = this.translate.instant('Wirklich löschen?');

        myDialog = custom({
          title: txtTitle,
          messageHtml: txtMsg,
          buttons: [
            {
              text: txtYes,
              onClick: (e) => {
                return { buttonText: true };
              }
            },
            {
              text: txtNo,
              onClick: (e) => {
                return { buttonText: false };
              }
            }
          ]
        });
        myDialog.show().then((dialogResult) => {
          if (dialogResult.buttonText == true) {
            this.http
              .delete('api/product/DeleteProduct/' + this.selectedCustomerId + '/' + this.selectedTreeId)
              .subscribe(() => {
                this.treeListTarget.instance.refresh();

                if (this.selectedSourceCatalogId == this.selectedTargetCatalogId) {
                  this.treeListSource.instance.refresh();
                }

                this.modelService.catalogService
                  .getSpidsInCatalog(this.selectedTargetCatalogId, this.selectedCustomerId)
                  .subscribe((response: Array<string>) => {
                    this.existingSpids = response;
                  });
              });
          }
        });

        break;
    }
  }

  // eig. scheisse, duplicate code, aber im catalog.service.ts ist der TREE fest verdrahtet...
  // abgekupfert aus: \Pim\ClientApp\src\app\Services\catalog.service.ts
  async addCategory(parentId: string, customerId: string, treeId: string, newCategoryName: string) {
    let addItemModel = new AddItem();
    addItemModel.parentId = parentId;
    addItemModel.customerId = customerId;
    addItemModel.parentTreeId = treeId;
    addItemModel.newCategoryName = newCategoryName;

    this.http.post<StringResponse>('api/category/AddCategory', addItemModel).subscribe((response: StringResponse) => {
      this.refreshTargetTree(treeId);
      if (this.selectedSourceCatalogId == this.selectedTargetCatalogId) {
        this.refreshSourceTree(treeId);
      }
    });
  }

  txtCopy: string = '';
  txtMove: string = '';
  txtReference: string = '';

  selectedOperation: OperationEntity;

  operationsAll: OperationEntity[];
  operationsNonVirtualSameCatalog: OperationEntity[];
  operationsNonVirtualNotSameCatalog: OperationEntity[];
  operationsNonVirtual: OperationEntity[];
  operationsVirtual: OperationEntity[];

  isTargetCatalogVirtual: boolean = false;

  operationsDisabled: boolean = false;

  resetOperations() {
    this.operationsNonVirtual = this.operationsAll;
    this.selectedOperation = this.operationsNonVirtual[0];
    this.operationsDisabled = true;
  }

  setSelectedOperation() {
    if (this.selectedSourceCatalogId == null || this.selectedTargetCatalogId == null) {
      return;
    }

    if (this.isOnboarding) {
      this.operationsNonVirtual = this.operationsNonVirtualNotSameCatalog;
      this.selectedOperation = this.operationsNonVirtualNotSameCatalog[1];
      this.operationsDisabled = true;
      return;
    }

    let catalog = this.targetCatalogs.filter((c) => c.id == this.selectedTargetCatalogId)[0];

    if (catalog != null && !catalog.isVirtual && this.selectedSourceCatalogId == this.selectedTargetCatalogId) {
      this.operationsNonVirtual = this.operationsNonVirtualSameCatalog;
      this.selectedOperation = this.operationsNonVirtualSameCatalog[0];
      this.operationsDisabled = false;
    }

    if (catalog != null && !catalog.isVirtual && this.selectedSourceCatalogId != this.selectedTargetCatalogId) {
      this.operationsNonVirtual = this.operationsNonVirtualNotSameCatalog;
      this.selectedOperation = this.operationsNonVirtualNotSameCatalog[0];
      this.operationsDisabled = false;
    }

    if (catalog != null && catalog.isVirtual) {
      this.selectedOperation = this.operationsVirtual[0];
      this.operationsDisabled = true;
    }
  }

  get isSearchActive(): boolean {
    return !!(this._filterValue?.trim() || this.selectedStates?.length > 0 || this.catalogTreeSource?.activeSearchFormFilter);
  }

  get availableOperations(): OperationEntity[] {
    return this.operationsNonVirtual ?? [];
  }

  private applySearchFilter(model: TransferCatalogItem): void {
    if (this.isExplicitProductSubset()) {
      return;
    }

    const activeSearchForm = this.catalogTreeSource?.activeSearchFormFilter;
    if (activeSearchForm) {
      model.searchFormRequest = {
        formId: activeSearchForm.id,
        condition: activeSearchForm.filterCondition,
        criteria: activeSearchForm.searchOptions?.map(opt => ({
          systemKey: opt.nextPimField?.systemKey,
          elementKey: opt.nextPimField?.elementKey,
          field: opt.nextPimField?.field,
          operator: opt.operator,
          dataType: opt.dataType,
          value: opt.value,
          valueTo: opt.valueTo,
          values: opt.values
        })) ?? []
      };
    } else if (this._filterValue?.trim() || this.selectedStates?.length > 0) {
      model.searchFilter = this._filterValue ?? '';
      model.searchStates = [...(this.selectedStates ?? [])];
      model.searchAndStates = this.modelService.catalogService.selectedStatesMode === 'and';
      const opts = this.modelService.loginService.currentUser?.productSearchOptions;
      model.searchFields = opts?.searchFields?.map(f => f.searchField) ?? [];
      model.searchMode = opts?.searchMode ?? 'Contains';
    }
  }

  private isExplicitProductSubset(): boolean {
    const selectedData = this.treeListSource.instance.getSelectedRowsData() as TreeItem[];
    if (selectedData.some(t => t.type === 'grp' || t.type === 'cat')) {
      return false;
    }

    const selectedProductCount = selectedData.filter(t => t.type === 'pro').length;
    if (selectedProductCount === 0) {
      return false;
    }

    return selectedProductCount < this.collectProductKeys(this.treeListSource.instance).length;
  }

  private deduplicateSourceSelection(selectedData: TreeItem[]): TreeItem[] {
    const selectedCategoryIds = new Set(
      selectedData.filter(t => t.type === 'grp').map(t => t.treeElementId.toString())
    );
    if (selectedCategoryIds.size === 0) 
      return selectedData;

    const visibleRows = this.treeListSource.instance.getVisibleRows();
    const allRowsByKey = new Map<string, TreeItem>(
      visibleRows.map((r: any) => [r.key.toString(), r.data])
    );

    const isDescendantOfSelectedCategory = (item: TreeItem): boolean => {
      let parentKey = item.parent?.toString();
      while (parentKey && parentKey !== '0') {
        if (selectedCategoryIds.has(parentKey)) return true;
        const parentData = allRowsByKey.get(parentKey);
        if (!parentData)
          break;
        parentKey = parentData.parent?.toString();
      }
      return false;
    };

    const result = selectedData.filter(item =>
      item.type !== 'pro' || !isDescendantOfSelectedCategory(item)
    );

    const existingKeys = new Set(result.map(r => r.treeElementId.toString()));
    for (const product of this.preDragSelectedProducts) {
      if (!existingKeys.has(product.treeElementId.toString()) && isDescendantOfSelectedCategory(product)) {
        result.push(product);
      }
    }

    return result;
  }

  private async openConflictDialog(productName: string): Promise<'use-source' | 'keep-target' | null> {
    const title = this.translate.instant('Konflikt erkannt');
    const msg = this.translate.instant(
      'Achtung: Sie fügen gerade den Artikel {{prodName}} in den Zielkatalog in eine andere Kategorie hinzu. Welche Daten sollen beim Artikel erhalten bleiben?',
      { prodName: productName }
    );
    const btnSource = this.translate.instant('Daten aus dem Quellkatalog übernehmen');
    const btnTarget = this.translate.instant('Daten aus dem Zielkatalog beibehalten');
    const btnCancel = this.translate.instant('Abbrechen');

    const dlg = custom({
      title,
      messageHtml: msg,
      buttons: [
        { text: btnSource, onClick: () => ({ choice: 'use-source' }) },
        { text: btnTarget, onClick: () => ({ choice: 'keep-target' }) },
        { text: btnCancel, onClick: () => ({ choice: null }) },
      ],
    });
    const r: any = await dlg.show();
    return r?.choice ?? null;
  }

  private async openBatchConflictDialogForCategories(): Promise<'use-source' | 'keep-target' | null> {
    const dlg = custom({
      title: this.translate.instant('Konflikte behandeln'),
      messageHtml: this.translate.instant(
        'Beim Kopieren von Kategorien und Produkten kann es zu Duplikaten (gleiche SupplierPID) im Zielkatalog kommen. Wie sollen Konflikte standardmäßig behandelt werden?'
      ),
      buttons: [
        { text: this.translate.instant('Daten aus dem Quellkatalog übernehmen'), onClick: () => ({ choice: 'use-source' as const }) },
        { text: this.translate.instant('Daten aus dem Zielkatalog beibehalten'), onClick: () => ({ choice: 'keep-target' as const }) },
        { text: this.translate.instant('Abbrechen'), onClick: () => ({ choice: null }) },
      ],
    });
    const r: any = await dlg.show();
    return r?.choice ?? null;
  }

  public changeMergeStrategy(event: any) {
    if(event.value){
      this.modelMergestrategy = event.value;
    }
  }

  protected readonly LoginService = LoginService;
}

export class OperationEntity {
  id: number;
  text: string;
  disabled?: boolean;
}
